var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarPayingAccount(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#FFBF19"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3521 5.74608C11.32 5.87986 11.2504 6.00294 11.1541 6.09391L9.60761 7.60296L9.97149 9.7274C9.99825 9.86118 9.98219 10.0003 9.92868 10.1287C9.88052 10.2572 9.78955 10.3696 9.67717 10.4498C9.5648 10.5301 9.43637 10.5782 9.29724 10.589C9.1581 10.5943 9.02432 10.5675 8.90124 10.5033L7.00155 9.50265L5.09651 10.5033C4.97343 10.5675 4.83965 10.5997 4.70052 10.589C4.56139 10.5836 4.43296 10.5354 4.32058 10.4552C4.2082 10.3696 4.11723 10.2625 4.06907 10.1341C4.01556 10.0057 3.9995 9.86653 4.02091 9.7274H4.02626L4.39015 7.60296L2.84899 6.09926C2.74731 6.00294 2.67775 5.87986 2.64564 5.75143C2.61353 5.61765 2.61888 5.47851 2.66169 5.34473C2.69915 5.2163 2.77942 5.09858 2.8811 5.00761C2.98812 4.92199 3.11655 4.86312 3.25033 4.84172L5.38548 4.53134L6.338 2.59955C6.40221 2.47647 6.49318 2.36944 6.61091 2.29988C6.72864 2.22496 6.86242 2.1875 7.00155 2.1875C7.14068 2.1875 7.27447 2.22496 7.39219 2.29988C7.50457 2.36944 7.60089 2.47647 7.65976 2.59955L8.61228 4.53134L10.7474 4.84172C10.8866 4.86312 11.0096 4.91663 11.1167 5.00761C11.2183 5.09858 11.2986 5.21095 11.3414 5.34473C11.3842 5.47316 11.3842 5.6123 11.3521 5.74608Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarPayingAccount);
export default __webpack_public_path__ + "static/media/star-paying-account.0a6e7fcd.svg";
export { ForwardRef as ReactComponent };